import { Divider, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import styles from './index.module.less'
import { RoleTypes } from '@/constants/index'
import UserContent from './UserContent'
import AssistantContent from './AssistantContent'
import Related from './Related'

export default function ChatItem({ item, isLast, isShare }: any) {
  if (item.stop === 2) {
    return (
      <Divider plain={true} className={styles.newChatDivider}>
        全新的开始
      </Divider>
    )
  }
  return (
    <>
      {item.role === RoleTypes.user && (
        <UserContent item={item} isShare={isShare} />
      )}
      {item.role === RoleTypes.assistant && (
        <div className="flex flex-col gap-4">
          <AssistantContent item={item} isLast={isLast} />
          {isLast &&
            item.out_finished &&
            !item.related &&
            item.risklevel &&
            !item.reasoning_content && (
              <div
                className={styles.related}
                style={{ display: 'inline-block' }}
              >
                <img
                  className="w-5 h-5"
                  src="https://zdtc-cdn.wair.ac.cn/public/loadding.gif"
                />
              </div>
            )}
          {isLast && item.related?.length > 0 && (
            <Related related={item.related} />
          )}
        </div>
      )}
    </>
  )
}
